import { useQuery } from "@tanstack/react-query";
import type { FeatureFlagView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useFeatureFlagsQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.featureFlags(),
    queryFn: () =>
      apiJsonClient<FeatureFlagView[]>(endpoints.admin.featureFlags),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
